export const PLAYER_SETTINGS = {
  exchangeConnectTimeout: 60 * 60 * 1000,
  exchangeUrl: "https://cdn.cloud.vstreamcdn.net/player/v3/config",
  auth: {
    provider: "cupis",
    platform: "cupis-v2",
    merchant: "site",
    projectId: "cupis",
  },
};

export const STREAM_SETTINGS = {
  game: "carracing",
  view: "main",
  quality: "360p",
};
